import axios from 'axios'

// 获取记事列表
export function getNoteList(params) {
  // 后端期望参数：pageNum, pageSize, keyword, type
  return axios.get(process.env.VUE_APP_BASE_API + '/note/list', { params })
}

// 获取单个记事
export function getNote(id) {
  return axios.get(process.env.VUE_APP_BASE_API + `/note/get/${id}`)
}

// 更新记事
export function updateNote(data) {
  return axios.post(process.env.VUE_APP_BASE_API + '/note/update', data)
}

export function addNote(data) {
  return axios.post(process.env.VUE_APP_BASE_API + '/note/add', data)
}

// 删除记事
export function deleteNote(id) {
  return axios.post(process.env.VUE_APP_BASE_API + `/note/delete/${id}`)
}

// 获取历史版本列表
export function getNoteHistory(params) {
  return axios.post(process.env.VUE_APP_BASE_API + '/note/history/getByNoteId', params)
}

// 获取单个历史版本详情
export function getNoteHistoryDetail(id) {
  return axios.get(process.env.VUE_APP_BASE_API + `/note/history/get/${id}`)
}

export default {
  getNoteList,
  getNote,
  updateNote,
  addNote,
  deleteNote,
  getNoteHistory,
  getNoteHistoryDetail
}
